<div [ngClass]="getInitialsBg(name)" class="avatar-placeholder-wrapper" [style.--size]="size">
    <span>{{ getInitials(name) }}</span>
</div>
